export default "__VITE_PUBLIC_ASSET__484775f8__"